import { render, staticRenderFns } from "./ReportCategory.vue?vue&type=template&id=224212e0&scoped=true"
import script from "./ReportCategory.vue?vue&type=script&lang=js"
export * from "./ReportCategory.vue?vue&type=script&lang=js"
import style0 from "./ReportCategory.vue?vue&type=style&index=0&id=224212e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224212e0",
  null
  
)

export default component.exports